import { render } from "./EntregasCorreioView.vue?vue&type=template&id=469dfbf0&scoped=true"
import script from "./EntregasCorreioView.vue?vue&type=script&lang=js"
export * from "./EntregasCorreioView.vue?vue&type=script&lang=js"

import "./EntregasCorreioView.vue?vue&type=style&index=0&id=469dfbf0&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469dfbf0"]])

export default __exports__